import './App.css';
import { FunctionComponent } from 'react';

interface Props {
  children: React.ReactNode;
  url?: string;
}

export const Link: FunctionComponent<Props> = ({ children, url }) => {
  return (
    <a
      className="App-link"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  );
}

export default Link;
